import React, { useState, useEffect } from "react";
import { loadWidgetsFromConfig, GroupField } from "react-invenio-forms";
import { Button, Form, Icon } from "semantic-ui-react";
import { i18next } from "@translations/invenio_rdm_records/i18next";

const RepeatableFieldRow = ({
  fieldConfig,
  fieldPath,
  indexPath,
  arrayHelpers,
  templateLoaders,
}) => {
  const [widget, setWidget] = useState(null);

  const path = `${fieldPath}[${indexPath}]`;

  useEffect(() => {
    const loadRowWidget = async () => {
      const config = {...fieldConfig, props: {...fieldConfig.props, icon: null}}
      const loadedWidgets = await loadWidgetsFromConfig({
        templateLoaders,
        fields: [
          {
            ...config,
            field: path,
          },
        ],
      });
      setWidget(loadedWidgets[0]);
    };

    loadRowWidget();
  }, [fieldConfig, templateLoaders, fieldPath, indexPath]);

  if (!widget) return null;

  return (
    <GroupField optimized>
      <div className="custom-repeatable-field-input">{widget}</div>

      <Button
        aria-label={i18next.t("Remove field")}
        className="close-btn custom-repeatable-field-close-btn"
        icon
        onClick={() => arrayHelpers.remove(indexPath)}
      >
        <Icon name="close" />
      </Button>
    </GroupField>
  );
};

export default RepeatableFieldRow;
